import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

export const checkoutTransactionsShape = ImmutablePropTypes.mapOf(
  ImmutablePropTypes.mapOf(
    PropTypes.bool,
    PropTypes.oneOf(['isCheckingOut', 'isLockingFormat', 'isRenewing', 'isReturning', 'isQuickRenewing'])
  ),
  PropTypes.string
);
